<template>
  <div id="curriculum">

    <div class="inner card">
      <div v-if="!save_curriculum">
        <div id="top">
          <input type="text" v-model="curriculum_name" placeholder="Curriculum name">
          <div class="btnPrimary" @click="saveCurriculum">Save Curriculum</div>
        </div>
        <main>
          <div class="concept" v-for="concept in all_concepts">
            <div class="conceptUnit">
              <h2>{{concept.name}}</h2>

              <div class="conceptCards">

                <div v-for="course in concept.course_resource" class="courseCard spaceBetween" :class="{removed:!course.show}">
                  <a target="_blank" :href="course.location_url" v-bind:key="course.course_object.url_object_id" class="courseContent">
                    <div class="card shadowOnHover">
                      <div class="courseImg" v-bind:style="{ backgroundImage: 'url(' + course.course_object.image_url + ')' }"></div>
                      <div class="info">
                        <p class="note">{{course.course_object.provider}} | via {{course.course_object.platform}}</p>
                        <h4 v-html="course.course_object.name"></h4>
                        <div class="snippet">
                          <p v-if="course.module_number" class="note snippetIndex">{{course.module_number}}</p>
                          <p class="note snippetName">{{course.module_text}}</p>
                        </div>
                        <!-- <div v-for="mileseone in course.milestone"> -->
                          <!-- <p v-if="mileseone.milestone_number" class="note">{{mileseone.milestone_number}}</p> -->
                          <!-- <p v-if="mileseone.milestone_title">{{mileseone.milestone_title}}</p> -->
                        <!-- </div> -->
                      </div>
                    </div>
                  </a>
                  <div class="remove" @click="course.show=false" v-if="course.show"><i class="far fa-trash-alt"></i><span class="note">REMOVE</span></div>
                  <div class="addBack" @click="course.show=true" v-if="!course.show"><i class="far fa-plus-square"></i><span class="note">ADD BACK</span></div>
                </div>

                <div v-for="book in concept.book_resource" class="bookCard spaceBetween" :class="{removed:!book.show}">
                  <a v-bind:href="book.book_object.link" target="_blank"  class="bookContent">
                    <div class="card shadowOnHover">
                      <div class="bookImg" v-bind:style="{ backgroundImage: 'url(' + book.book_object.image_url + ')' }"></div>
                      <div class="typetag"><p class="note">book</p></div>
                      <div class="info">
                        <p>{{book.location_text}}</p>
                        <h4 v-html="book.book_object.title"></h4>
                        <p v-if="book.book_object.author" class="note">by <span v-for="name in book.book_object.author" class="note">{{name}}</span></p>
                        <p v-if="book.book_object.pages" class="note">{{book.book_object.pages}} pages</p>
                        <p class="note" v-if="book.book_object.publisher">Published <span v-if="book.book_object.last_published_date" class="note">{{book.book_object.last_published_date}} </span>by {{book.book_object.publisher}}</p>
                        <p v-if="book.book_object.isbn" class="note">ISBN 13: {{book.book_object.isbn}}</p>
                      </div>
                    </div>
                  </a>
                  <div class="remove" @click="book.show=false" v-if="book.show"><i class="far fa-trash-alt"></i><span class="note">REMOVE</span></div>
                  <div class="addBack" @click="book.show=true" v-if="!book.show"><i class="far fa-plus-square"></i><span class="note">ADD BACK</span></div>
                </div>

              </div>

            </div>
          </div>
          <i class="fas fa-map-marker-alt"></i>
        </main>

        <div id="congratulation">
          <div id="crown"></div>
          <h2>Bravo!</h2>
          <h4>You have finished your learning path, well done!</h4>
          <div class="btnPrimary" @click="saveCurriculum">Save Curriculum</div>
        </div>

      </div>

      <div id="curriculumGenerated" v-else>
        <div id="bookshelf"></div>
        <h2>New Curriculum generated!</h2>
        <p>You can now learn following the <span>{{curriculum_name}}</span>.</p>
        <div class="btnPrimary" @click="download">Download Curriculum</div>
        <div id="newCurriculum" style="padding:30px; width: 100%;">
          <h1 style=" border-bottom: 1px solid #EBECEF; padding-bottom: 10px;">{{curriculum_name}}</h1>
          <div class="concept" v-for="concept in all_concepts" style="width:100%;">
            <div class="conceptUnit">
              <h2 style="border-left:6px solid #FA6400; padding-left: 20px;margin-left: 0px; transform: translateY(0px); margin-top: 40px;">{{concept.name}}</h2>

              <div class="conceptCards" style="padding:10px 0px; border: none;">

                <div v-for="course in concept.course_resource" class="courseCard" style="display: block;">
                  <a target="_blank" :href="course.location_url" v-bind:key="course.course_object.url_object_id" class="courseContent">
                    <div class="pdfCard" style="border:1px solid #EBECEF; padding:20px 30px; border-radius: 12px;">
                      <div class="info">
                        <p class="note">{{course.course_object.provider}} | via {{course.course_object.platform}}</p>
                        <h4 v-html="course.course_object.name"></h4>
                        <div class="snippet">
                          <p v-if="course.module_number" class="note snippetIndex">{{course.module_number}}</p>
                          <p class="note snippetName">{{course.module_text}}</p>
                        </div>
                        <!-- <div v-for="mileseone in course.milestone"> -->
                          <!-- <p v-if="mileseone.milestone_number" class="note">{{mileseone.milestone_number}}</p> -->
                          <!-- <p v-if="mileseone.milestone_title">{{mileseone.milestone_title}}</p> -->
                        <!-- </div> -->
                      </div>
                    </div>
                  </a>
                </div>

                <div v-for="book in concept.book_resource" class="bookCard" style="display: block;">
                  <a v-bind:href="book.book_object.link" target="_blank"  class="bookContent">
                    <div class="pdfCard" style="border:1px solid #EBECEF; padding:20px 30px; border-radius: 12px;">
                      <div class="info">
                        <p class="note" style="color:#B19967">book</p>
                        <p>{{book.location_text}}</p>
                        <h4 v-html="book.book_object.title"></h4>
                        <p v-if="book.book_object.author" class="note">by <span v-for="name in book.book_object.author" class="note">{{name}}</span></p>
                        <p v-if="book.book_object.pages" class="note">{{book.book_object.pages}} pages</p>
                        <p class="note" v-if="book.book_object.publisher">Published <span v-if="book.book_object.last_published_date" class="note">{{book.book_object.last_published_date}} </span>by {{book.book_object.publisher}}</p>
                        <p v-if="book.book_object.isbn" class="note">ISBN 13: {{book.book_object.isbn}}</p>
                      </div>
                    </div>
                  </a>
                </div>

              </div>

            </div>
          </div>
        </div>
      </div>

    </div>


  </div>
</template>

<script>
    import { jsPDF } from "jspdf";
    import html2pdf from 'html2pdf.js'
    import html2canvas from 'html2canvas'
    import {getGoalConceptCurriculum} from "../../api/api";

    export default {
        name: "Curriculum",
        data(){
            return{
                curriculum_name:"",
                save_curriculum:false,
                all_concepts:[
                    // {
                    //     name:"Conditional probability",
                    //     related_course:[
                    //         {
                    //             url_object_id: "0000",
                    //             title:"An Intuitive Introduction to Probability",
                    //             provider:"University of Zurich",
                    //             platform:"Coursera",
                    //             milestone:[
                    //                 {
                    //                     milestone_number:"Week 2",
                    //                     milestone_title:"Conditional Probability"
                    //                 }
                    //             ],
                    //             link:"https://www.coursera.org/lecture/introductiontoprobability/intuition-XkzT7",
                    //             image_url:"https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/https://coursera-course-photos.s3.amazonaws.com/34/453010a2a211e69e5b2d62ff69e8ef/MOOC_Decision_making_World_Coursera_1200x1200.jpg",
                    //             show:true
                    //         },
                    //         {
                    //             url_object_id: "0001",
                    //             title: "Probability Theory, Statistics and Exploratory Data Analysis",
                    //             provider: "National Research University Higher School of Economics",
                    //             platform: "Coursera",
                    //             milestone:[
                    //                 {
                    //                     milestone_number: "Week 1",
                    //                     milestone_title: "Conditional probability and Independence"
                    //                 }
                    //             ],
                    //             link: "https://www.coursera.org/lecture/probability-theory-statistics/introduction-to-the-2nd-week-0hH3F",
                    //             image_url: "https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/https://coursera-course-photos.s3.amazonaws.com/c5/56b130f1274048a3a40d200d0e7fa8/Probability-theory-statistics-and-exploratory-data-analysis.jpg",
                    //             show: true
                    //         },
                    //         {
                    //             url_object_id: "0002",
                    //             title: "Introduction to Stochastic Processes",
                    //             provider: "Massachusetts Institute of Technology",
                    //             platform: "MIT OpenCourseWare",
                    //             milestone:[
                    //                 {
                    //                     milestone_number: "SES #15",
                    //                     milestone_title: "Conditional Expectation and Introduction to Martingales"
                    //                 }
                    //             ],
                    //             link: "https://ocw.mit.edu/courses/mathematics/18-445-introduction-to-stochastic-processes-spring-2015/lecture-notes/MIT18_445S15_lecture15.pdf",
                    //             image_url: "https://ocw.mit.edu/courses/mathematics/18-445-introduction-to-stochastic-processes-spring-2015/18-445s15.jpg",
                    //             show: true
                    //         }
                    //     ],
                    //     related_book:[]
                    // },
                    // {
                    //     name:"Expectation and variance",
                    //     related_course:[
                    //         {
                    //             url_object_id: "0003",
                    //             title: "Probability Theory, Statistics and Exploratory Data Analysis",
                    //             provider: "National Research University Higher School of Economics",
                    //             platform: "Coursera",
                    //             milestone:[
                    //                 {
                    //                     milestone_number: "Week 3",
                    //                     milestone_title: "Systems of random variables; properties of expectation and variance, covariance and correlation."
                    //                 }
                    //             ],
                    //             link: "https://www.coursera.org/lecture/probability-theory-statistics/introduction-to-the-3rd-week-C3h65",
                    //             image_url: "https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/https://coursera-course-photos.s3.amazonaws.com/c5/56b130f1274048a3a40d200d0e7fa8/Probability-theory-statistics-and-exploratory-data-analysis.jpg",
                    //             show: true
                    //         },
                    //         {
                    //             url_object_id: "0004",
                    //             title: "Fat Chance: Probability from the Ground Up",
                    //             provider: "Harvard University",
                    //             platform: "edX",
                    //             milestone:[
                    //                 {
                    //                     milestone_number: "4",
                    //                     milestone_title: "Expected Value"
                    //                 }
                    //             ],
                    //             link: "https://learning.edx.org/course/course-v1:HarvardX+FC1x+1T2021/block-v1:HarvardX+FC1x+1T2021+type@sequential+block@f3fcb67b869345fd8e3aaf4405cfe5d4/block-v1:HarvardX+FC1x+1T2021+type@vertical+block@00af2925e8cf447b93816ca8bec23110",
                    //             image_url: "https://prod-discovery.edx-cdn.org/media/course/image/97f16f83-5e8a-496c-9086-5634c8edccbb-95970686ef9b.small.jpg",
                    //             show: true
                    //         }
                    //     ],
                    //     related_book:[]
                    // },
                    // {
                    //     name:"Multivariate distributions",
                    //     related_course:[
                    //         {
                    //             url_object_id: "0005",
                    //             title: "Probability and Random Variables",
                    //             provider: "Massachusetts Institute of Technology",
                    //             platform: "MIT OpenCourseWare",
                    //             milestone:[
                    //                 {
                    //                     milestone_number: "SES #2",
                    //                     milestone_title: "Multinomial coefficients and more counting"
                    //                 }
                    //             ],
                    //             link: "https://ocw.mit.edu/courses/mathematics/18-600-probability-and-random-variables-fall-2019/lecture-notes/MIT18_600F19_lec2.pdf",
                    //             image_url: "https://ocw.mit.edu/courses/mathematics/18-600-probability-and-random-variables-fall-2019/18-600f19.jpg",
                    //             show: true
                    //         },
                    //         {
                    //             url_object_id: "0006",
                    //             title: "Fundamentals of Probability",
                    //             provider: "Massachusetts Institute of Technology",
                    //             platform: "MIT OpenCourseWare",
                    //             milestone:[
                    //                 {
                    //                     milestone_number: "L14",
                    //                     milestone_title: "Multivariate Normal"
                    //                 },
                    //                 {
                    //                     milestone_number: "L15",
                    //                     milestone_title: "Multivariate Normal. Characteristic Functions"
                    //                 }
                    //             ],
                    //             link: "https://ocw.mit.edu/courses/electrical-engineering-and-computer-science/6-436j-fundamentals-of-probability-fall-2018/lecture-notes/MIT6_436JF18_lec14.pdf",
                    //             image_url: "https://ocw.mit.edu/courses/electrical-engineering-and-computer-science/6-436j-fundamentals-of-probability-fall-2018/6-436F18.jpg",
                    //             show: true
                    //         }
                    //     ],
                    //     related_book:[
                    //         {
                    //             url_object_id: "0000",
                    //             title: "Bayesian Reasoning and Machine Learning",
                    //             chapter: "Section 9.1, \"Learning as inference,\" pgs. 189-193 external-link",
                    //             author: ["David Barber"],
                    //             page: 697,
                    //             publish_time: "April 1st 2012",
                    //             publisher: "Cambridge University Press",
                    //             isbn: "9780521518147",
                    //             image_url: require("../../assets/img/Book/book1.jpg"),
                    //             url: "https://books.google.ca/books?id=E7ogAwAAQBAJ&printsec=frontcover&dq=Bayesian+Reasoning+and+Machine+Learning&hl=en&sa=X&ved=2ahUKEwiQgvv3mfDuAhXIGs0KHQmgCccQ6AEwAXoECAQQAg#v=onepage&q=Bayesian%20Reasoning%20and%20Machine%20Learning&f=false",
                    //             show:true
                    //         }
                    //     ]
                    // }
                ]
            }
        },
        methods:{
          checkParam: function (p) {
            if (p && (typeof p != "string")) {
              return (p.join())
            }
            else {
              return p
            }
          },
            getCurriculum: function(){
              if (this.$route.params.goal){
                getGoalConceptCurriculum({
                  id: this.$route.params.goal,
                  // mastered: this.$route.params.mastered,
                  ma: this.checkParam(this.$route.query.ma)
                }).then((response) => {
                  this.all_concepts = response.data.prerequisite_nodes_resource
                  this.all_concepts.push(response.data.goal_node)
                })
              }
            },

            saveCurriculum:function(){
                this.save_curriculum = true;
                if (this.curriculum_name===""){
                    this.curriculum_name="Untitled curriculum"
                }
                let i;
                for (i=0; i<this.all_concepts.length;i++){
                  if (this.all_concepts[i].course_resource){
                    this.all_concepts[i].course_resource = this.all_concepts[i].course_resource.filter(function(item){return item.show});
                  }
                  else{
                    this.all_concepts[i].course_resource = [];
                  }
                  if (this.all_concepts[i].book_resource){
                    this.all_concepts[i].book_resource = this.all_concepts[i].book_resource.filter(function(item){return item.show});
                  }
                  else{
                    this.all_concepts[i].book_resource = [];
                  }
                }
                this.all_concepts = this.all_concepts.filter(function(item){
                  return item.course_resource.length>0 || item.book_resource.length>0
                })
            },
            download:function(){
                const element = document.getElementById("newCurriculum");
                html2pdf().from(element).save("Curriculum");
                return true;
            }
        },
        created(){
          this.getCurriculum();
        }
    }
</script>

<style>
  @import '../../assets/style/general.css';
  @import '../../assets/style/map.css';
</style>



// WEBPACK FOOTER //
// src/view/Map/Curriculum.vue